// import './navbar.css'
// const Navbar = () => {
//   return (
//          <header className="header js-header">
//       <div className="container">
//         <div className="logo" data-aos="fade-down" data-aos-duration="1000">
//           <a href="/">
//             <img src="/img/logo.png" alt="logo" style={{ maxWidth: "80px", height: "60px" }} />
//           </a>
//         </div>
//         <button className="nav-toggler js-nav-toggler" data-aos="fade-down" data-aos-duration="1000">
//           <span></span>
//         </button>
//         <nav className="nav js-nav">
//           <ul  data-aos="fade-down" data-aos-duration="1000">
//             <li><a href="#home">home</a></li>
//             <li><a href="#about">about</a></li>
//             <li><a href="#services">services</a></li>
//             <li><a href="#testimonials">Testimonials</a></li>
//             <li><a href="#contact">contact</a></li>
//           </ul>
//         </nav>
//       </div>
//      </header>
//   )
// }

// export default Navbar

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const toggleNav = () => {
    setNavOpen(prev => !prev);
  };

  const closeNav = () => {
    setNavOpen(false);
    setServicesOpen(false);
    setLocationsOpen(false);
  };

  const scrollToSection = (sectionId) => {
    closeNav();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    { name: 'End of Lease Cleaning', slug: 'end-of-lease-cleaning-point-cook' },
    { name: 'Carpet Cleaning', slug: 'carpet-cleaning-melbourne' },
    { name: 'Domestic Cleaning', slug: 'domestic-cleaning-sunshine' },
    { name: 'Commercial Cleaning', slug: 'commercial-cleaning-werribee' },
    { name: 'Office Cleaning', slug: 'office-cleaning-melbourne' },
    { name: 'Window Cleaning', slug: 'window-cleaning-truganina' },
    { name: 'Concrete Cleaning', slug: 'concrete-cleaning-hoppers-crossing' },
    { name: 'Builders Clean', slug: 'builders-clean-williams-landing' },
    { name: 'BnB Cleaning', slug: 'bnb-cleaning-parkville' },
  ];

  const locations = [
    { name: 'Point Cook', slug: 'cleaners-point-cook' },
    { name: 'Werribee', slug: 'cleaners-werribee' },
    { name: 'Sunshine', slug: 'cleaners-sunshine' },
    { name: 'Truganina', slug: 'cleaners-truganina' },
    { name: 'Hoppers Crossing', slug: 'cleaners-hoppers-crossing' },
    { name: 'Williams Landing', slug: 'cleaners-williams-landing' },
    { name: 'Parkville', slug: 'cleaners-parkville' },
    { name: 'Melbourne', slug: 'cleaners-melbourne' },
  ];

  return (
    <header className="header js-header">
      <div className="container">
        <div className="logo" data-aos="fade-down" data-aos-duration="1000">
          <Link to="/" onClick={closeNav}>
            <img src="/img/logo.png" alt="Niks Elite Cleaning Logo" style={{ maxWidth: "80px", height: "60px" }} />
          </Link>
        </div>
        <button
          className={`nav-toggler js-nav-toggler ${navOpen ? 'active' : ''}`}
          onClick={toggleNav}
        >
          <span></span>
        </button>
        <nav className={`nav js-nav ${navOpen ? 'open' : ''}`}>
          <ul data-aos="fade-down" data-aos-duration="1000">
            <li>
              {isHome ? (
                <a href="#home" onClick={() => scrollToSection('home')}>Home</a>
              ) : (
                <Link to="/" onClick={closeNav}>Home</Link>
              )}
            </li>
            <li>
              {isHome ? (
                <a href="#about" onClick={() => scrollToSection('about')}>About</a>
              ) : (
                <Link to="/#about" onClick={closeNav}>About</Link>
              )}
            </li>
            <li 
              className="dropdown" 
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <span
                className="dropdown-toggle"
                tabIndex={0}
                onClick={e => {
                  setServicesOpen(prev => !prev);
                  // Prevent scroll if on home and dropdown is being toggled
                  if (isHome) e.preventDefault();
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setServicesOpen(prev => !prev);
                    e.preventDefault();
                  }
                }}
                aria-haspopup="true"
                aria-expanded={servicesOpen}
                role="button"
              >
                Services <i className="fas fa-chevron-down"></i>
              </span>
              <ul className={`dropdown-menu ${servicesOpen ? 'show' : ''}`}>
                {services.map((service) => (
                  <li key={service.slug}>
                    <Link to={`/${service.slug}`} onClick={closeNav}>
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li 
              className="dropdown" 
              onMouseEnter={() => setLocationsOpen(true)}
              onMouseLeave={() => setLocationsOpen(false)}
            >
              <span
                className="dropdown-toggle"
                tabIndex={0}
                onClick={e => {
                  setLocationsOpen(prev => !prev);
                  e.preventDefault();
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setLocationsOpen(prev => !prev);
                    e.preventDefault();
                  }
                }}
                aria-haspopup="true"
                aria-expanded={locationsOpen}
                role="button"
              >
                Locations <i className="fas fa-chevron-down"></i>
              </span>
              <ul className={`dropdown-menu ${locationsOpen ? 'show' : ''}`}>
                {locations.map((location) => (
                  <li key={location.slug}>
                    <Link to={`/${location.slug}`} onClick={closeNav}>
                      {location.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li>
              {isHome ? (
                <a href="#testimonials" onClick={() => scrollToSection('testimonials')}>Testimonials</a>
              ) : (
                <Link to="/#testimonials" onClick={closeNav}>Testimonials</Link>
              )}
            </li>
            <li>
              {isHome ? (
                <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
              ) : (
                <Link to="/#contact" onClick={closeNav}>Contact</Link>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
